import { render, staticRenderFns } from "./PlatStatistics.vue?vue&type=template&id=68b3983f&"
import script from "./PlatStatistics.vue?vue&type=script&lang=ts&"
export * from "./PlatStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PlatStatistics.vue"
export default component.exports